export class RestoreAwsOpenSearchDomainRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "AwsOpenSearchDomainRestoreDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAwsOpenSearchDomainRequest.attributeTypeMap;
    }
    constructor() {
    }
}
